import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="main-footer">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <img 
                src="/images/logo.png" 
                alt="Dactrha" 
                className="h-10 w-10 rounded-lg object-contain bg-white p-1"
              />
              <span className="text-xl font-bold text-white">{t('common.appName')}</span>
            </Link>
            <p className="text-sm text-slate-400">
              {t('common.tagline')}
            </p>
            <div className="flex gap-3">
              <a href="#" className="p-2 rounded-full bg-slate-800 hover:bg-teal-600 transition-colors" aria-label="Facebook">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="#" className="p-2 rounded-full bg-slate-800 hover:bg-teal-600 transition-colors" aria-label="Twitter">
                <Twitter className="h-4 w-4" />
              </a>
              <a href="#" className="p-2 rounded-full bg-slate-800 hover:bg-teal-600 transition-colors" aria-label="Instagram">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="#" className="p-2 rounded-full bg-slate-800 hover:bg-teal-600 transition-colors" aria-label="LinkedIn">
                <Linkedin className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('nav.home')}</h3>
            <ul className="space-y-2">
              <li><Link to="/doctors" className="text-sm hover:text-teal-400 transition-colors">{t('nav.doctors')}</Link></li>
              <li><Link to="/specialties" className="text-sm hover:text-teal-400 transition-colors">{t('nav.specialties')}</Link></li>
              <li><Link to="/appointments" className="text-sm hover:text-teal-400 transition-colors">{t('nav.appointments')}</Link></li>
              <li><Link to="/about" className="text-sm hover:text-teal-400 transition-colors">{t('nav.about')}</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.contactUs')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0 text-teal-400" />
                <span>123 Healthcare Blvd, Medical District</span>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <Phone className="h-4 w-4 flex-shrink-0 text-teal-400" />
                <span>+1 (555) 123-4567</span>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <Mail className="h-4 w-4 flex-shrink-0 text-teal-400" />
                <span>contact@dactrha.com</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-sm hover:text-teal-400 transition-colors">{t('footer.privacyPolicy')}</Link></li>
              <li><Link to="/terms" className="text-sm hover:text-teal-400 transition-colors">{t('footer.termsOfService')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-slate-800 text-center text-sm text-slate-500">
          <p>&copy; {currentYear} {t('common.appName')}. {t('footer.allRightsReserved')}.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
